<template>
  <v-container fluid grid-list-lg>
    <!--<v-btn @click.prevent="loadResults">refresh</v-btn>-->
    <v-progress-circular indeterminate color="primary" v-show="loading"></v-progress-circular>
    <v-alert
      v-if="!loading && results.length === 0"
      :value="true"
      color="info"
      icon="info"
      outline
    >Nu exista rezultate.</v-alert>
    <v-layout row wrap>
      <v-flex xs12 v-for="offer in results" :key="offer.id_oferta">
        <result :offer="offer" :query="query"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Oferta from './Oferta.vue';
  import Furnizor from './Furnizor.vue';
  import {loader} from '@/modules/electric/index.js';
  import Result from './Result.vue';

  export default {
    data() {
      return {
        loading: false,
        query: undefined,
        results: []
      }
    },
    computed: {
      ...mapGetters(['language']),
      fuiObligator() {
        const offer = this.results.reverse()[0];
        if (offer === undefined) {
          return 0;
        }
        return parseFloat(offer.valoare_factura_furnizor_fc);
      }
    },
    methods: {
      loadResults() {
        this.loading = true;

        return loader(this.language, this.query)
          .then(r => r.json()
            .then(results => {
              if (r.ok) {
                this.results = results.data;
              } else {
                return Promise.reject(new Error(results.message || r.statusText));
              }
            })
            .catch(e => {
              console.log(e);
              console.log(r);
            })
          )
          .catch(e => {
            console.log(e);
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    mounted() {
      this.query = this.$route.query;
      this.loadResults();
    },
    beforeRouteUpdate(to, from, next) {
      this.query = to.query;
      this.loadResults();
      next();
    },
    components: {
      Result,
      Oferta,
      Furnizor
    }
  }
</script>
